// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Markdown Styles */

.markdown-paragraph {
  margin-bottom: 1em;
}

.markdown-paragraph > * {
  margin: 0;
}

/* Style for headings */
.markdown-paragraph h1,
.markdown-paragraph h2,
.markdown-paragraph h3,
.markdown-paragraph h4,
.markdown-paragraph h5,
.markdown-paragraph h6 {
  font-family: 'Crimson Text', serif;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  font-weight: 600;
  line-height: 1.2;
}

/* Style for bold text */
.markdown-paragraph strong {
  font-weight: 700;
}

/* Style for italic text */
.markdown-paragraph em {
  font-style: italic;
}

/* Style for links within markdown */
.markdown-paragraph a {
  color: #0366d6;
  text-decoration: none;
}

.markdown-paragraph a:hover {
  text-decoration: underline;
}

/* Style for code */
.markdown-paragraph code {
  background-color: rgba(27, 31, 35, 0.05);
  border-radius: 3px;
  font-family: monospace;
  padding: 0.2em 0.4em;
  font-size: 85%;
}

/* Style for blockquotes */
.markdown-paragraph blockquote {
  border-left: 0.25em solid #dfe2e5;
  padding-left: 1em;
  color: #6a737d;
  margin: 0;
}

/* Style for lists */
.markdown-paragraph ul,
.markdown-paragraph ol {
  padding-left: 2em;
  margin: 0.5em 0;
}

.markdown-paragraph li {
  margin-bottom: 0.25em;
}

/* Style for horizontal rule */
.markdown-paragraph hr {
  height: 0.25em;
  padding: 0;
  margin: 1.5em 0;
  background-color: #e1e4e8;
  border: 0;
}

/* Make sure content in the description panel is properly styled */
.scene-description .markdown-paragraph {
  margin: 0;
}

/* Ensure Markdown content works with two-column layout */
@media (min-width: 768px) {
  .story-text[style*="column-count: 2"] .markdown-paragraph {
    display: inline-block;
    width: 100%;
    break-inside: avoid-column;
  }
} `, "",{"version":3,"sources":["webpack://./src/assets/markdown.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA,uBAAuB;AACvB;;;;;;EAME,kCAAkC;EAClC,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,wCAAwC;EACxC,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA,oBAAoB;AACpB;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,SAAS;AACX;;AAEA,kEAAkE;AAClE;EACE,SAAS;AACX;;AAEA,yDAAyD;AACzD;EACE;IACE,qBAAqB;IACrB,WAAW;IACX,0BAA0B;EAC5B;AACF","sourcesContent":["/* Markdown Styles */\n\n.markdown-paragraph {\n  margin-bottom: 1em;\n}\n\n.markdown-paragraph > * {\n  margin: 0;\n}\n\n/* Style for headings */\n.markdown-paragraph h1,\n.markdown-paragraph h2,\n.markdown-paragraph h3,\n.markdown-paragraph h4,\n.markdown-paragraph h5,\n.markdown-paragraph h6 {\n  font-family: 'Crimson Text', serif;\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n/* Style for bold text */\n.markdown-paragraph strong {\n  font-weight: 700;\n}\n\n/* Style for italic text */\n.markdown-paragraph em {\n  font-style: italic;\n}\n\n/* Style for links within markdown */\n.markdown-paragraph a {\n  color: #0366d6;\n  text-decoration: none;\n}\n\n.markdown-paragraph a:hover {\n  text-decoration: underline;\n}\n\n/* Style for code */\n.markdown-paragraph code {\n  background-color: rgba(27, 31, 35, 0.05);\n  border-radius: 3px;\n  font-family: monospace;\n  padding: 0.2em 0.4em;\n  font-size: 85%;\n}\n\n/* Style for blockquotes */\n.markdown-paragraph blockquote {\n  border-left: 0.25em solid #dfe2e5;\n  padding-left: 1em;\n  color: #6a737d;\n  margin: 0;\n}\n\n/* Style for lists */\n.markdown-paragraph ul,\n.markdown-paragraph ol {\n  padding-left: 2em;\n  margin: 0.5em 0;\n}\n\n.markdown-paragraph li {\n  margin-bottom: 0.25em;\n}\n\n/* Style for horizontal rule */\n.markdown-paragraph hr {\n  height: 0.25em;\n  padding: 0;\n  margin: 1.5em 0;\n  background-color: #e1e4e8;\n  border: 0;\n}\n\n/* Make sure content in the description panel is properly styled */\n.scene-description .markdown-paragraph {\n  margin: 0;\n}\n\n/* Ensure Markdown content works with two-column layout */\n@media (min-width: 768px) {\n  .story-text[style*=\"column-count: 2\"] .markdown-paragraph {\n    display: inline-block;\n    width: 100%;\n    break-inside: avoid-column;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
